<script setup lang="ts">
import { useRouter } from 'vue-router';
import { setUnauthorizedHandler } from './api';
import { session, setSession } from './session';
import { i18n, type Locale } from './i18n';
import { routeName } from './router';
import { setupUserTheme } from './theme';

const router = useRouter();
setupUserTheme();

// Sitzung abgelaufen (401 bei einem API-Aufruf): zur Anmeldung
setUnauthorizedHandler(() => {
  // Nur eine bestehende Sitzung kann ablaufen; auf öffentlichen Seiten
  // (FAQ, Blacklist, ...) führt ein 401 nicht zur Anmeldeseite
  if (!session.value) return;
  setSession(null);
  void router.push({ name: routeName('login', i18n.global.locale.value as Locale) });
});
</script>

<template>
  <RouterView />
</template>
